import { RestClient } from '@/api/rest-client'
import { ReferralNode } from '@/api/model/referral-node'
import { cloneDeep } from 'lodash'
import { Company } from '@/api/model/company'
import { CompanyAPI } from '@/api/backend-client'

export class ReferralNodeClient extends RestClient<ReferralNode> {
    collectionName = 'referral_nodes'
    parseData = ReferralNode.fromData

    async create(data: ReferralNode): Promise<ReferralNode> {
        const request = cloneDeep<any>(data)

        if (data.source instanceof Company) {
            request.source = data.source.resourceIdentifier
        }

        if (data.target instanceof Company) {
            request.target = data.target.resourceIdentifier
        }

        // A link changed: the companies in CompanyAPI's cache may show more or less now
        const node = await super.create(request)
        CompanyAPI.forgetRelatedCompanies()

        return node
    }

    async update(id: string, data: ReferralNode): Promise<ReferralNode> {
        const request = cloneDeep<any>(data)

        if (data.source instanceof Company) {
            request.source = data.source.resourceIdentifier
        }

        if (data.target instanceof Company) {
            request.target = data.target.resourceIdentifier
        }

        const node = await super.update(id, request)
        CompanyAPI.forgetRelatedCompanies()

        return node
    }
}
